// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { headerShipToAddressStyles } from "@rpsc/Overrides/Widgets/Common/HeaderShipToAddress";
import IconLocationDot from "@rpsc/XDL/Icons/IconLocationDot";
import IconPencilEdit from "@rpsc/XDL/Icons/IconPencilEdit";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { css } from "styled-components";

headerShipToAddressStyles.textWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

headerShipToAddressStyles.titleIcon = {
    src: IconLocationDot,
    size: 14,
    color: "common.white",
    css: css`
        &,
        & > svg {
            height: 19px;
            width: 11px;
        }
        margin-right: 8px;
    `,
};

headerShipToAddressStyles.changeIcon = {
    src: IconPencilEdit,
    size: 14,
    color: "common.white",
    css: css`
        &,
        & > svg {
            height: 19px;
            width: 14px;
        }
        margin-left: 8px;
    `,
};

headerShipToAddressStyles.titleClickable = {
    css: css`
        width: 100%;
        display: flex;
        gap: 4px;
        && {
            align-items: center;
        }
        &:hover {
            .edit-icon {
                opacity: 0.66;
            }
        }
    `,
};

headerShipToAddressStyles.labelTypography = {
    variant: "h6",
    forwardAs: "p",
    css: css`
        line-height: 17px;
        margin-bottom: 0;
    `,
};

headerShipToAddressStyles.titleTypography = {
    ellipsis: true,
    css: css`
        &&& {
            font-weight: ${fontConfig.weight.regular};
        }
    `,
};
